<script setup>
import { computed } from "vue";

const props = defineProps({
  partnerLevelType: {
    type: String,
    default: "",
  },
  height: {
    type: String,
    default: "54px",
  },
  width: {
    type: String,
    default: "92px",
  },
});

const levelPartnerImageAltText = computed(() => `Partner ${props.partnerLevelType} level logo image`);
const partnerLevelImageSrc = computed(() => {
  const levelLogoImages = {
    SILVER: require("@/assets/SAP_SilverPartnerLogo_new.avif"),
    GOLD: require("@/assets/SAP_GoldPartnerLogo_new.avif"),
    PLATINUM: require("@/assets/SAP_PlatinumPartnerLogo_new.avif"),
  };
  return levelLogoImages[props.partnerLevelType?.toUpperCase()];
});
</script>

<template>
  <div class="flex justify-center" automation-id="partnerLevel-logo">
    <img
      v-if="partnerLevelType"
      :alt="levelPartnerImageAltText"
      :src="partnerLevelImageSrc"
      :style="{ width: props.width, height: props.height }"
    />
  </div>
</template>